﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ForecastService
 * @description
 * # ForecastService
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ForecastService', ['$http', '$q', 'FlashService', function ($http, $q, FlashService) {

      function defaultHeader() {
          return {
              data: {
                  forecastOptionsSummary: null
              }
          };
      }

      var header = defaultHeader();

      function getForecastHeader(fullReload) {
          var deferred = $q.defer();
          if (header.data.forecastOptionsSummary && !fullReload) {
              deferred.resolve(header);
          } else {
              $http.get('/api/Forecast/Header').then(function (result) {
                  angular.extend(header.data, result.data);
                  deferred.resolve(header);
              }, handleError);
          }
          return deferred.promise;
      }

      function setForecastHeader(data) {
          if (!header.data.forecastOptionsSummary) {
              header.data.forecastOptionsSummary = {};
          }

          header.data.isForecastOptions = true;
          header.data.forecastOptionsSummary.forecastScope = data.forecastScope;
          header.data.forecastOptionsSummary.forecastView = data.forecastView;
          header.data.forecastOptionsSummary.weeklyDisplay = data.weeklyDisplay;
          header.data.forecastOptionsSummary.testScenariosOnly = data.testScenariosOnly;
      }

      function getForecastOptions() {
          return $http.get('/api/Forecast/ForecastOptions').then(handleSuccess, handleError);
      }

      function setForecastOptions(data) {
          return $http.post('/api/Forecast/ForecastOptions', data).then(handleSuccess, handleError);
      }

      function reloadStaffBlockHeader(data) {
          return $http.post('/api/Forecast/ReloadStaffBlockHeader', data).then(handleSuccess, handleError);
      }

      function getForecastStaff(data) {
          return $http.post('/api/Forecast/StaffBlockHeader', data).then(handleSuccess, handleError);
      }

      function getForecastStaffGrid(data) {
          return $http.post('/api/Forecast/DOWActivities', data).then(handleSuccess, handleError); 
      }

      function getRoomScheduleHeader(data) {
          return $http.post('/api/Forecast/RoomScheduleHeader', data).then(handleSuccess, handleError);
      }

      function getOtherActivitiesHeaders(data) {
          return $http.post('/api/Forecast/OtherActivitiesHeader', data).then(handleSuccess, handleError);
      }

      function getRoomDOWActivities(data) {
          return $http.post('/api/Forecast/RoomDOWActivities', data).then(handleSuccess, handleError);
      }

      function getOtherDOWActivities(data) {
          return $http.post('/api/Forecast/OtherDOWActivities', data).then(handleSuccess, handleError);
      }
      
      function getForecastUnAssignedActivities(data) {
          return $http.post('/api/Forecast/UnAssignedActivities', data).then(handleSuccess, handleError);
      }

      function getForecastUnAssignedActivitiesFilter(data) {
          return $http.post('/api/Forecast/UnAssignedActivitiesFilter', data).then(handleSuccess, handleError);
      }

      function getForecastUnAssignedActivitiesByDate(data) {
          return $http.post('/api/Forecast/UnAssignedActivitiesByDate', data).then(handleSuccess, handleError);
      }

      function getForecastBorrowResources(data) {
          return $http.post('/api/Forecast/BorrowResources', data).then(handleSuccess, handleError);
      }

      function getStaffInfoFilter(data) {
          return $http.post('/api/Forecast/StaffInfoFilter', data).then(handleSuccess, handleError);
      }

      function getStafInfo(data) {
          return $http.post('/api/Forecast/StaffInfo', data).then(handleSuccess, handleError);
      }

      function setDayOfWeekActions(data) {
          return $http.post('/api/Forecast/SetDayOfWeekActions', data).then(handleSuccess, handleError);
      }

      function getCensusProjections(data) {
          return $http.post('/api/Forecast/CensusProjections', data).then(handleSuccess, handleError);
      }

      function saveCensusProjections(data) {
          return $http.post('/api/Forecast/SaveCensusProjections', data).then(handleSuccess, handleError);
      }

      function generateScenario() {
          return $http.get('/api/ScenarioGenerator/ScenarioGeneratorPreValidation').then(handleSuccess, handleError);
      }

      function getScenarioNotes(scenarioId) {
          return $http.get('/api/Forecast/GetScenarioNotes?scenarioId=' + scenarioId).then(handleSuccess, handleError);
      }

      function saveScenarioNotes(data) {
          return $http.post('/api/Forecast/SaveScenarioNotes', data).then(handleSuccess, handleError);
      }

      function cancelScenario(data) {
          return $http.post('/api/Forecast/CancelScenario', data).then(handleSuccess, handleError);
      }

      function getAttendanceProjections(data) {
          return $http.post('/api/Forecast/AttendanceProjections', data).then(handleSuccess, handleError);
      }

      function getAttendanceReport(data) {
          return $http.post('/api/Forecast/AttendanceReport', data).then(handleSuccess, handleError);
      }

      function applyScenario(data) {
          return $http.post('/api/Forecast/ApplyScenario', data).then(handleSuccess, handleError);
      }

      function getStarScenarioButtonType() {
          return $http.get('/api/Forecast/StarScenarioButtonType').then(handleSuccess, handleError);
      }

      function dragSchedulеActivity(data) {
          return $http.post('/api/Forecast/DragSchedulеActivity', data).then(handleSuccess, handleError);
      }

      function dragSchedulеActivitiesGroup(data) {
          return $http.post('/api/Forecast/RescheduleActivityToOtherStaff', data).then(handleSuccess, handleError);
      }

      function getForecastSummaryMenu(data) {
          return $http.post('/api/Forecast/ForecastSummaryMenu', data).then(handleSuccess, handleError);
      }

      function listAllChanges(data) {
          return $http.post('/api/Forecast/ListAllChanges', data).then(handleSuccess, handleError);
      }

      function saveListAllChanges(data) {
          return $http.post('/api/Forecast/SaveListAllChanges', data).then(handleSuccess, handleError);
      }

      function getUnderAllocatedStaff(data) {
          return $http.post('/api/Forecast/UnderAllocatedStaff', data).then(handleSuccess, handleError);
      }

      function assignPersonIntoRoomAssignmentDOW(data) {
          return $http.post('/api/Forecast/DragIntoRoomAssignmentDOW', data).then(handleSuccess, handleError);
      }

      function assignPersonIntoRoomAssignmentLocate(data) {
          return $http.post('/api/Forecast/DragIntoAssignmentGroup', data).then(handleSuccess, handleError);
      }

      function assignPersonToRoomActivity(data) {
          return $http.post('/api/Forecast/DragIntoAssignmentRow', data).then(handleSuccess, handleError);
      }

      function unAssignedStaffByScheduleId(data) {
          return $http.post('/api/Forecast/UnAssignedStaffByScheduleId', data).then(handleSuccess, handleError);
      }


      function assignPersonIntoOtherAssignmentDOW(data) {
          return $http.post('/api/Forecast/AssignPersonIntoOtherAssignmentDOW', data).then(handleSuccess, handleError);
      }

      function assignPersonIntoOtherAssignmentLocate(data) {
          return $http.post('/api/Forecast/DragIntoAssignmentGroup', data).then(handleSuccess, handleError);
      }

      function assignPersonToOtherActivity(data) {
          return $http.post('/api/Forecast/DragIntoAssignmentRow', data).then(handleSuccess, handleError);
      }

      function rescheduleOtherActivity(data) {
          return $http.post('/api/Forecast/RescheduleActivity', data).then(handleSuccess, handleError);
      }

      function rescheduleActivity(data) {
          return $http.post('/api/Forecast/RescheduleActivity', data).then(handleSuccess, handleError);
      }

      function getStaffAttends(data) {
          return $http.post('/api/Forecast/GetStaffAttends', data).then(handleSuccess, handleError);
      }

      function getStaffGrid(data) {
          return $http.post('/api/Forecast/BorrowResourcesGrid', data).then(handleSuccess, handleError);
      }

      function borrowStaff(data) {
          return $http.post('/api/Forecast/Borrowed', data).then(handleSuccess, handleError);
      }

      function undoBorrowStaff(data) {
          return $http.post('/api/Forecast/UndoBorrowed', data).then(handleSuccess, handleError);
      }

      function handleSuccess(res) {
          return { success: true, data: res.data };
      }

      function handleError(error) {
          FlashService.Error(error.data.errors.toString()); 
          return { success: false };
      }

      function dispose() {
          header = defaultHeader();
      }

      var service = {};

      service.GetForecastHeader = getForecastHeader;
      service.SetForecastHeader = setForecastHeader;
      service.GetForecastOptions = getForecastOptions;
      service.SetForecastOptions = setForecastOptions;
      service.GetForecastStaff = getForecastStaff;
      service.GetForecastStaffGrid = getForecastStaffGrid;
      service.GetRoomScheduleHeader = getRoomScheduleHeader;
      service.GetOtherActivitiesHeaders = getOtherActivitiesHeaders;
      service.GetRoomDOWActivities = getRoomDOWActivities;
      service.GetOtherDOWActivities = getOtherDOWActivities;
      service.ReloadStaffBlockHeader = reloadStaffBlockHeader;
      service.GetForecastUnAssignedActivities = getForecastUnAssignedActivities;
      service.GetForecastUnAssignedActivitiesFilter = getForecastUnAssignedActivitiesFilter;
      service.GetForecastUnAssignedActivitiesByDate = getForecastUnAssignedActivitiesByDate;
      service.GetForecastBorrowResources = getForecastBorrowResources;
      service.GetStaffInfoFilter = getStaffInfoFilter;
      service.GetStafInfo = getStafInfo;
      service.SetDayOfWeekActions = setDayOfWeekActions;
      service.GetCensusProjections = getCensusProjections;
      service.SaveCensusProjections = saveCensusProjections;
      service.GenerateScenario = generateScenario;
      service.GetScenarioNotes = getScenarioNotes;
      service.SaveScenarioNotes = saveScenarioNotes;
      service.CancelScenario = cancelScenario;
      service.GetAttendanceReport = getAttendanceReport;
      service.GetAttendanceProjections = getAttendanceProjections;
      service.ApplyScenario = applyScenario;
      service.GetStarScenarioButtonType = getStarScenarioButtonType;
      service.DragSchedulеActivity = dragSchedulеActivity;
      service.RescheduleActivity = rescheduleActivity;
      service.DragSchedulеActivitiesGroup = dragSchedulеActivitiesGroup;
      service.GetForecastSummaryMenu = getForecastSummaryMenu;
      service.ListAllChanges = listAllChanges;
      service.SaveListAllChanges = saveListAllChanges;
      service.GetUnderAllocatedStaff = getUnderAllocatedStaff;
      service.AssignPersonIntoRoomAssignmentDOW = assignPersonIntoRoomAssignmentDOW;
      service.AssignPersonIntoRoomAssignmentLocate = assignPersonIntoRoomAssignmentLocate;
      service.AssignPersonToRoomActivity = assignPersonToRoomActivity;
      service.AssignPersonIntoOtherAssignmentDOW = assignPersonIntoOtherAssignmentDOW;
      service.AssignPersonIntoOtherAssignmentLocate = assignPersonIntoOtherAssignmentLocate;
      service.AssignPersonToOtherActivity = assignPersonToOtherActivity;
      service.RescheduleOtherActivity = rescheduleOtherActivity;
      service.GetStaffAttends = getStaffAttends;
      service.Dispose = dispose;
      service.UnAssignedStaffByScheduleId = unAssignedStaffByScheduleId;
      service.GetStaffGrid = getStaffGrid;
      service.BorrowStaff = borrowStaff;
      service.UndoBorrowStaff = undoBorrowStaff;
      return service;
  }]);